/* Host-side recording: draws every tile onto a branded canvas and mixes all audio; streams data to onData. */
export const pickMime = () => ["video/webm;codecs=vp9,opus", "video/webm;codecs=vp8,opus", "video/webm", "video/mp4"].find(t => window.MediaRecorder?.isTypeSupported?.(t)) || "";

export function startRecording(getVideos, getStreams, logoUrl, onData, type = pickMime()) {
  const W = 1280, H = 720;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const logo = new Image(); logo.crossOrigin = "anonymous"; logo.src = logoUrl;
  const draw = () => {
    ctx.fillStyle = "#0b1220"; ctx.fillRect(0, 0, W, H);
    const vids = getVideos().filter(v => v.readyState >= 2 && v.videoWidth);
    const spot = vids.find(v => v.dataset.screen === "1");
    const list = spot ? [spot] : vids;
    const cols = Math.ceil(Math.sqrt(list.length || 1)), rows = Math.ceil((list.length || 1) / cols);
    const cw = W / cols, ch = (H - 60) / rows;
    list.forEach((v, i) => {
      const r = Math.min(cw / v.videoWidth, ch / v.videoHeight), w = v.videoWidth * r, h = v.videoHeight * r;
      const x = (i % cols) * cw + (cw - w) / 2, y = Math.floor(i / cols) * ch + (ch - h) / 2;
      ctx.drawImage(v, x, y, w, h);
      if (logo.complete && logo.naturalWidth) {
        const lh = Math.max(18, Math.min(40, h * 0.08)), lw = logo.naturalWidth * lh / logo.naturalHeight;
        ctx.save(); ctx.shadowColor = "rgba(0,0,0,0.7)"; ctx.shadowBlur = 3;
        ctx.drawImage(logo, x + w - lw - 10, y + h - lh - 10, lw, lh); ctx.restore();
      }
    });
    ctx.fillStyle = "rgba(15,23,42,0.85)"; ctx.fillRect(0, H - 60, W, 60);
    ctx.fillStyle = "#94a3b8"; ctx.font = "16px sans-serif"; ctx.fillText(new Date().toLocaleString(), W - 230, H - 24);
  };
  const timer = setInterval(draw, 1000 / 15);
  const ac = new AudioContext();
  const dest = ac.createMediaStreamDestination();
  const wired = new Set();
  const wire = () => getStreams().forEach(s => { if (s && !wired.has(s.id) && s.getAudioTracks().length) { wired.add(s.id); ac.createMediaStreamSource(s).connect(dest); } });
  wire();
  const wireTimer = setInterval(wire, 2000);
  const out = new MediaStream([...canvas.captureStream(15).getVideoTracks(), ...dest.stream.getAudioTracks()]);
  const rec = new MediaRecorder(out, type ? { mimeType: type } : undefined);
  rec.ondataavailable = (e) => e.data.size && onData(e.data);
  rec.start(1000);
  return () => new Promise(resolve => {
    rec.onstop = () => {
      clearInterval(timer); clearInterval(wireTimer); ac.close();
      resolve();
    };
    rec.stop();
  });
}
